import { createSelector,createSlice } from '@reduxjs/toolkit';
import { defaultFiltersWithStatus } from 'common/types/FiltersWithStatus';
import { getReducers, statusesList } from 'common/utils/statusHelpers';

import type { RootState } from '../../app/store';

const initialState = defaultFiltersWithStatus;

const ClaimUserMembershipSlice = createSlice({
    name: 'claimUserMembership',
    initialState,
    reducers: getReducers()
});

// eslint-disable-next-line no-restricted-syntax
export default ClaimUserMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkStatusFilter } = ClaimUserMembershipSlice.actions;
export const selectFilters = (state: RootState) => state.claimUserMembership.filters;

// Memoized selector to prevent unnecessary rerenders
const selectStatusKeys = (state: RootState) => state.claimUserMembership.filters.dropdowns.status.keys;

export const selectFilteredStatus = createSelector(
    [selectStatusKeys],
    (statusKeys) => statusesList.filter(statusName => statusKeys.includes(statusName))
);
